import { useEffect } from "react";
import { KYC_FLOW_FINISHED_MESSAGE } from "../../pages/kyc/KycComplete";
import styles from "./KycVerificationFrame.module.css";

// Shows Didit's hosted KYC flow (session url from the backend) in an iframe.
// onFinished is called when Didit redirects to /kyc-complete inside the
// iframe. That only means the user finished; the result comes from the
// backend (webhook), so callers poll the KYC status after this.
// Didit's page is on another origin and does not report its height, so the
// iframe cannot size itself to its content. With fill, the iframe takes the
// full height of its parent (a flex column with a set height, see
// .hostWrapper) and only Didit's own page scrolls when it is taller.
const KycVerificationFrame = ({
  url,
  onFinished,
  title = "KYC",
  fill = false,
}) => {
  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type !== KYC_FLOW_FINISHED_MESSAGE) return;
      onFinished?.(event.data);
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [onFinished]);

  // Didit has its own language picker, so ours is hidden while the iframe
  // is on screen (see KycVerificationFrame.module.css).
  useEffect(() => {
    if (!url) return;
    document.body.classList.add("kyc-frame-open");
    return () => document.body.classList.remove("kyc-frame-open");
  }, [url]);

  if (!url) return null;

  return (
    <iframe
      className={`${styles.frame} ${fill ? styles.fill : ""}`}
      src={url}
      title={title}
      allow="camera; microphone; fullscreen; autoplay; encrypted-media"
    />
  );
};

export default KycVerificationFrame;
